import './landing-page.scss';
//import { setupGA } from '../../src/module/google-analytics';
import { appConfig } from '../../src/appConfig';
//import { setupPixel } from '../../src/module/facebook-pixel';
//import * as $ from 'jquery';
import { setupEnquiryForm, EnquiryFormType } from '../Shared/Component/EnquiryForm/enquiry-form';
import { setupSessionRecord } from '../../src/module/session-record';

//setupGA(appConfig.googleAnalyticsId, {
//    Id: appConfig.googleAdsId,
//    convertor: {
//        'landingPageForm': 'KeGoCO2l7tIBEKWb9voC'
//    }
//});
//setupPixel(appConfig.facebookPixelId);
setupEnquiryForm(EnquiryFormType.Course);

if (location.host.startsWith('192.168') || location.host.startsWith('localhost')) {
    // skip
}
else {
    setupSessionRecord(appConfig.sessionRecordId);
}

// 10 秒后 scroll 就不算 bounce rate
setTimeout(() => {
    const handleScroll = () => {
        window.removeEventListener('scroll', handleScroll);
        gtag('event', 'scroll', {
            send_to: appConfig.googleAnalyticsId,
            event_category: 'engagement'
        });
        gtag('event', 'scroll', {
            send_to: appConfig.googleAnalytics4Id
        });
        fbq('trackCustom', 'scroll');
    }
    window.addEventListener('scroll', handleScroll);
}, 10000);

// ga tracking
const links = Array.from(document.querySelectorAll<HTMLLinkElement>('a'));
for (const link of links) {
    if (link.href.startsWith('https://api.whatsapp.com')) {
        link.addEventListener('click', () => {
            gtag('event', 'whatsapp', {
                send_to: appConfig.googleAnalyticsId,
                event_category: 'engagement'
            });
            gtag('event', 'generate_lead', {
                send_to: appConfig.googleAnalytics4Id
            });
            gtag('event', 'whatsapp', {
                send_to: appConfig.googleAnalytics4Id
            });
            fbq('track', 'Contact');
        });
    }
}



//document.querySelector<HTMLLinkElement>('#js-introductionVideoLink').addEventListener('click', () => {
//    gtag('event', 'play_video', {
//        send_to: appConfig.googleAnalyticsId,
//        event_category: 'engagement',
//        event_label: 'Introduction'
//    });

//    // note 解忧: ga4 video 会自动 track 的, 如果确定它会自动 track 这里就可以洗掉了
//    gtag('event', 'play_video', {
//        send_to: appConfig.googleAnalytics4Id,
//        name: 'Introduction'
//    });

//    // TODO now
//    // note 解忧: fb 就不 track 了, 感觉没有合适的 event 也不太重要
//});




//$(document).ready(function () {
//    const postData = {
//        action: 'newEnquiry',
//        module: 'simtrain',
//        uid: 'dev',
//        token: '78723jk12b413jkb4133129u312',
//        // date: '2018-01-01',
//        parentName: '',
//        // parentIC: '871215-23-9999',
//        parentHP: '',
//        // parentEmail: 'dev5@simitgroup.com',
//        // parentOccupation: 'software Engineer',
//        studentName: '-',
//        // studentDOB: '2017-01-01',
//        // studentGender: 'Male',
//        // studentRaces: 'Chinese',
//        // studentReligion: 'Buddism',
//        // studentSchool: 'SEK.MEN.MOUNT AUSTIN',
//        // houseName: 'House',
//        // houseStreet1: '11, Jalan Molek 1/5B',
//        // houseStreet2: 'Taman Molet',
//        // houseStreet3: '81100 Johor Bahru',
//        // houseStreet4: 'Johor',
//        // housePostcode: '81100',
//        // houseCity: 'Taman Molek',
//        attendBefore: 'N',
//        // attendPlace: 'School 1',
//        branchCode: '',
//        knowUsFromCode: 'Facebook',
//        remark: ''
//    }

//    $("form button").click(function () {
//        var name = $("#name").val();
//        var hp = $("#hp").val();
//        var location = $("#location").val();
//        var message = $("#message").val();

//        if (name != "" && hp != "" && location != "" && message != "") {
//            jQuery('.myFormDefault').hide();
//            jQuery('.myFormLoading').show();

//            postData.parentName = name;
//            postData.parentHP = hp;
//            postData.branchCode = location;
//            postData.remark = message;

//            $.ajax({
//                cache: false,
//                //url: 'https://portal.klceducation.asia/d/klcdev/api.php',
//                //url: 'https://portal.klceducation.asia/s/klc/api.php',
//                //url: 'https://languagecentre.klceducation.asia/landing-page/enquiry',
//                url: 'http://192.168.1.152:61547/landing-page/enquiry',
//                dataType: 'json',
//                type: 'POST',
//                data: postData,
//                async: 1,
//                success: (json) => {
//                    if (json.status == "OK") {
//                        jQuery('.myFormLoading').hide();
//                        jQuery('.myFormError').hide();
//                        jQuery('.myFormSuccess').show();
//                        jQuery('input,textarea,select').val('');
//                        gtag_formSubmitted2(location);
//                    }
//                    else if (json.status == "Failed") {
//                        alert("Failed, please resubmit or refresh.")
//                        jQuery('.myFormLoading').hide();
//                        jQuery('.myFormError').show();
//                    }
//                }
//            });
//        }
//    })

//    $('form').ajaxForm();

//    var scrolled = false;
//    $(window).scroll(function () {
//        if (!scrolled) {
//            scrollDimension();
//            scrolled = true;
//        }
//    });

//});
